import type { SuspendResponse } from '../../repositories/account-repo/schemas/suspend.zod';

export class Suspend {
  constructor(private apiResponse: SuspendResponse) {}

  public getSuspendPlanId() {
    return this.apiResponse.suspendPlanId;
  }

  public getSuspendPlanGroupId() {
    return this.apiResponse.suspendPlanGroupId;
  }

  public getPreSuspendPlanGroupId() {
    return this.apiResponse.preSuspendPlanGroupId;
  }

  public getPreSuspendPlanId() {
    return this.apiResponse.preSuspendPlanId;
  }

  public getSuspendDate() {
    return this.apiResponse.suspendDate;
  }

  public getSuspendReasonId() {
    return this.apiResponse.suspendReasonId;
  }

  public getSuspendSubReasonId() {
    return this.apiResponse.suspendSubReasonId;
  }
}
